import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import LoadingSpinner from "../components/LoadingSpinner";
import apiClient from "../api/apiClient";
import Heropage from "./Heropage";
import ShowMoreButton from "./ShowMoreButton";
import GoogleSocialLogin from "../components/Goooglelogin";
import announcementImage from "../assets/images/announcment.jpg";
import announcement2Image from "../assets/images/announcment2.jpg";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import ShowMoreButtonStatic from "./ShowMoreButtonStatic";
import { useSelector } from "react-redux";
import { getActiveSale, getSalePriceDisplay } from "../utils/saleUtils";
import SalePriceLabel from "../components/SalePriceLabel";

// Shared styled component for announcement headers
const AnnouncementHeader = styled("h1")(({ customColor }) => ({
  fontSize: "3.5rem !important",
  fontWeight: "bold !important",
  lineHeight: "1.2 !important",
  margin: "0 0 1rem 0 !important",
  color: customColor || "#000 !important",
  whiteSpace: "normal !important",
  textAlign: "center",
  "&.fw-bold": {
    fontSize: "3.5rem !important",
  },
}));

const Home = () => {
  const [MostPopular, setMostPopular] = useState([]);
  const { profiledata, fetchDataprofile } = useIndexPageData();
  const { role } = useSelector((state) => state.auth);
  const isAdmin = role === "A";
  const [FeaturedMockups, setFeaturedMockups] = useState([]);
  const [FreeMockups, setFreeMockups] = useState([]);
  const [NewMockups, setNewMockups] = useState([]);
  const [newBundles, setNewBundles] = useState([]);
  const [RandomMockups, setRandomMockups] = useState([]);
  const [randomCurrentPage, setRandomCurrentPage] = useState(0);
  const [randomPageTransitioning, setRandomPageTransitioning] = useState(false);
  const [loader, setloader] = useState(false);
  const [featuredSections, setFeaturedSections] = useState([]);

  const baseURL = process.env.REACT_APP_BASE_URL;

  // const fetchMostPopular = async () => {
  //   const result = await apiClient.get("/most-sold-listings/?page_size=8");
  //   if (result.ok) setMostPopular(result.data.results);
  // };

  const fetchFeaturedMockups = async () => {
    setloader(true);
    try {
      const result = await apiClient.get(
        "/featured-listings/?page_size=16&calledFrom=home",
      );
      if (result.ok) {
        setFeaturedMockups(result?.data?.results);
        const shuffled = result?.data?.results?.sort(() => 0.5 - Math.random());
        setRandomMockups(shuffled.slice(0, 15));
      }
    } finally {
      setloader(false);
    }
  };

  // const fetchFreeMockups = async () => {
  //   const result = await apiClient.get("/listings/?price=free&page_size=8");
  //   if (result.ok) setFreeMockups(result.data.results);
  // };

  // const fetchNewMockups = async () => {
  //   const result = await apiClient.get("/listings/?page_size=8");
  //   if (result.ok) setNewMockups(result.data.results);
  // };
  const fetchNewBundles = async () => {
    const result = await apiClient.get(
      "/bundle-listings/?page_size=16&calledFrom=home",
    );
    if (result.ok) setNewBundles(result.data.results);
  };

  const fetchHomePageListings = async () => {
    const result = await apiClient.get(
      `/homepage-listings/fetch/?page_size=16`,
    );
    if (result.ok) {
      setFreeMockups(result.data.free_listings);
      setNewMockups(result.data.new_listings);
      setMostPopular(result.data.most_sold_listings);
    }
  };

  const fetchFeaturedSections = async () => {
    try {
      const result = await apiClient.get(
        "/featured-sections/?page_size=2&called_from=home",
      );
      if (!result.ok) return;
      const list = result.data?.results ?? result.data ?? [];
      setFeaturedSections(Array.isArray(list) ? list.slice(0, 3) : []);
    } catch (err) {
      setFeaturedSections([]);
    }
  };

  // Helper function to pad IDs to 6 digits
  const formatMockupId = (id) => {
    return String(id).padStart(6, "0");
  };

  // const fetchRandomMockups = async () => {
  //   const result = await apiClient.get("/featured-listings/?page_size=30");

  //   if (result.ok && result.data?.results?.length > 0) {
  //     const shuffled = result.data.results.sort(() => 0.5 - Math.random());
  //     setRandomMockups(shuffled.slice(0, 9));
  //   } else {
  //     setRandomMockups([]);
  //   }
  // };

  // const fetchRandomMockups = async () => {
  //   if (FeaturedMockups && FeaturedMockups?.length > 0) {
  //     const shuffled = FeaturedMockups.sort(() => 0.5 - Math.random());
  //     setRandomMockups(shuffled.slice(0, 8));
  //   } else {
  //     setRandomMockups([]);
  //   }
  // };

  useEffect(() => {
    // fetchNewMockups();
    fetchFeaturedMockups();
    // fetchMostPopular();
    // fetchFreeMockups();
    // fetchRandomMockups();
    fetchNewBundles();
    fetchHomePageListings();
    fetchFeaturedSections();
  }, []);

  // useEffect(() => {
  //   fetchRandomMockups();
  // }, [FeaturedMockups]);

  const navigate = useNavigate();
  const handlenNavigateSearchpage = (key, value, title, heading) => {
    navigate(`/Searchpage?${key}=${value}`, { state: { des: title, heading } });
  };

  // Navigation functions for Random Mockups
  const getTotalPages = () => Math.ceil(RandomMockups.length / 3);

  const handleRandomPrevious = () => {
    if (randomPageTransitioning) return; // Prevent multiple rapid clicks

    setRandomPageTransitioning(true);
    setTimeout(() => {
      const totalPages = getTotalPages();
      setRandomCurrentPage((prev) => (prev > 0 ? prev - 1 : totalPages - 1));
      setTimeout(() => {
        setRandomPageTransitioning(false);
      }, 100); // Small delay to ensure new content is loaded
    }, 300); // Longer fade-out to accommodate staggered animations
  };

  const handleRandomNext = () => {
    if (randomPageTransitioning) return; // Prevent multiple rapid clicks

    setRandomPageTransitioning(true);
    setTimeout(() => {
      const totalPages = getTotalPages();
      setRandomCurrentPage((prev) => (prev < totalPages - 1 ? prev + 1 : 0));
      setTimeout(() => {
        setRandomPageTransitioning(false);
      }, 100); // Small delay to ensure new content is loaded
    }, 300); // Longer fade-out to accommodate staggered animations
  };

  const handleRandomPageClick = (pageIndex) => {
    if (randomPageTransitioning || pageIndex === randomCurrentPage) return;

    setRandomPageTransitioning(true);
    setTimeout(() => {
      setRandomCurrentPage(pageIndex);
      setTimeout(() => {
        setRandomPageTransitioning(false);
      }, 100); // Small delay to ensure new content is loaded
    }, 300); // Longer fade-out to accommodate staggered animations
  };

  /** Keep latest handler for autoplay interval (avoids stale closure). */
  const handleRandomNextRef = useRef(handleRandomNext);
  handleRandomNextRef.current = handleRandomNext;

  /** Auto-advance Random Mockup carousel on large screens; arrows/dots still work and reset the timer. */
  const RANDOM_MOCKUP_AUTOPLAY_MS = 3000;
  useEffect(() => {
    const totalPages = Math.ceil(RandomMockups.length / 3);
    if (totalPages <= 1 || RandomMockups.length === 0) return undefined;

    const id = window.setInterval(() => {
      handleRandomNextRef.current();
    }, RANDOM_MOCKUP_AUTOPLAY_MS);

    return () => window.clearInterval(id);
  }, [randomCurrentPage, RandomMockups.length]);

  // Get current page items (3 items per page)
  const getCurrentRandomItems = () => {
    const startIndex = randomCurrentPage * 3;
    return RandomMockups.slice(startIndex, startIndex + 3);
  };

  // Reset current page if it's out of bounds when RandomMockups changes
  useEffect(() => {
    const totalPages = getTotalPages();
    if (totalPages > 0 && randomCurrentPage >= totalPages) {
      setRandomCurrentPage(0);
    }
  }, [RandomMockups, randomCurrentPage]);

  const renderFeaturedSectionBlock = (section, index) => {
    if (!section) return null;
    const listings = section.mockups ?? section.listings ?? [];
    if (listings.length === 0) return null;
    const listingsCount = Number(section?.listings_count ?? 0);
    const showViewMore = listingsCount > 16;
    return (
      <section
        key={section.id}
        className="py-3 mb-lg-5"
        style={{ backgroundColor: index === 0 ? "#E3EBE0" : "#F7D2B4" }}
      >
        <div className="container">
          <h2 className="text-start fw-bold mb-1">{section.name}</h2>
          {section.description && (
            <p className="text-start mb-1">{section.description}</p>
          )}

          <div className="row mb-2">
            {listings.map((item) => {
              const listItem = item?.listing ?? item;
              const lid = listItem?.id;
              if (!lid) return null;
              return (
                <div
                  className=" col-6 col-lg-3 lg-mb-3 p-1 px-lg-2"
                  key={item?.id ?? lid}
                >
                  <div className="card p-2 shadow rounded-tr-lg h-100">
                    <Link
                      to={`/mockup?id=${lid}`}
                      className="card-img-wrapper position-relative"
                    >
                      <img
                        src={
                          listItem?.use_main_file_as_thumbnail
                            ? listItem?.compressed_file
                            : listItem?.thumbnails?.[0]?.image
                        }
                        className="card-img-top rounded-tr-lg w-full aspect-[4/5] object-contain"
                        alt=""
                      />
                      {(() => {
                        const sale = getActiveSale(listItem);
                        return sale.active &&
                          sale.percentage != null &&
                          !listItem?.is_free ? (
                          <div
                            className="position-absolute z-3 text-center fw-bold text-white small"
                            style={{
                              top: "10px",
                              left: "10px",
                              backgroundColor: "#C93312",
                              padding: "4px 10px",
                              borderRadius: "8px",
                              fontSize: "12px",
                            }}
                          >
                            Sale {sale.percentage}%
                          </div>
                        ) : null;
                      })()}
                    </Link>
                    <div className="card-body text-center">
                      <h5 className="card-title text-start mb-1 testelips d-none d-lg-block">
                        {listItem?.title}
                      </h5>
                      <p className="card-title text-start mb-1 testelips d-lg-none">
                        {listItem?.title}
                      </p>
                      <div
                        style={{
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          minHeight: "75px",
                        }}
                      >
                        <p
                          className="card-text text-start mb-1 d-none d-lg-block"
                          style={{ margin: 0, fontSize: "16px" }}
                        >
                          {listItem?.short_description}
                        </p>
                        <p
                          className="card-text text-start mb-1 d-lg-none"
                          style={{ margin: 0, fontSize: "14px" }}
                        >
                          {listItem?.short_description}
                        </p>
                      </div>
                      <div className="d-none d-lg-block">
                        <h2
                          className="d-flex fw-bold align-items-center gap-2 justify-content-center"
                          style={{ fontSize: "32px", marginTop: "16px" }}
                        >
                          {(() => {
                            const saleInfo = getActiveSale(listItem);
                            const salePrice = getSalePriceDisplay(listItem?.price, saleInfo);
                            return <SalePriceLabel salePrice={salePrice} />;
                          })()}
                        </h2>
                        {(listItem?.is_bought ?? item?.is_bought) ||
                          (listItem?.is_bundle_linked_and_bought ??
                            item?.is_bundle_linked_and_bought) ||
                          isAdmin ? (
                          <Link
                            to={`/mockup-editor?id=${lid}`}
                            className="grey-use mt-2 mb-hidden"
                            variant="contained"
                            style={{ textTransform: "capitalize" }}
                          >
                            Use
                          </Link>
                        ) : (
                          !profiledata?.is_suspended && (
                            <Link
                              to={`/mockup?id=${lid}`}
                              className="red-buy mt-2 mb-hidden"
                              variant="contained"
                              style={{ textTransform: "capitalize" }}
                            >
                              Buy
                            </Link>
                          )
                        )}
                        <div className="text-muted mt-2">
                          By{" "}
                          <Link
                            to={`/browse-mockups?name=${listItem?.user_id}`}
                            style={{
                              color: "#000",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "inline-block",
                              maxWidth: "150px",
                              verticalAlign: "bottom",
                            }}
                          >
                            {listItem?.user_name}
                          </Link>
                        </div>
                      </div>
                      <div className="d-lg-none d-flex flex-column flex-md-row justify-content-between align-items-center w-full">
                        {" "}
                        <h2
                          className="d-flex fw-bold align-items-center text-center gap-2"
                          style={{ fontSize: "32px", marginTop: "16px" }}
                        >
                          {(() => {
                            const saleInfo = getActiveSale(listItem);
                            const salePrice = getSalePriceDisplay(listItem?.price, saleInfo);
                            return <SalePriceLabel salePrice={salePrice} />;
                          })()}
                        </h2>
                        <div className="text-muted text-center mt-2">
                          By{" "}
                          <Link
                            to={`/browse-mockups?name=${listItem?.user_id}`}
                            style={{ color: "#000" }}
                          >
                            {listItem?.user_name}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {showViewMore && (
            <>
              <div className="d-none d-lg-flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "featured_section",
                      section.id,
                      section?.description || `Browse ${section?.name} mockups.`,
                      section?.name
                    )
                  }
                />
              </div>
              <div
                className="d-lg-none flex align-items-end justify-content-end"
              >
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "featured_section",
                      section.id,
                      section?.description || `Browse ${section?.name} mockups.`,
                      section?.name
                    )
                  }
                />
              </div>
            </>
          )}
        </div>

      </section>
    );
  };

  return (
    <>
      <div>
          <Heropage />

          <section
            className="py-3 mb-lg-5"
            style={{ backgroundColor: "#B9C4C8" }}
          >
            <div className="container">
              <h2 className="text-start fw-bold mb-1">Featured Mockups</h2>
              <p className="text-start mb-1">
                Browse our curated list of mockups.
              </p>

              <div className="row mb-2">
                {loader ? (
                  <div className="d-flex justify-content-center align-items-center py-5 w-100">
                    <LoadingSpinner color="#FF3E1F" />
                  </div>
                ) : (
                FeaturedMockups?.map((item) => (
                  <div
                    className=" col-6 col-lg-3 lg-mb-3 p-1 px-lg-2 "
                    key={item?.id}
                  >
                    <div className="card p-2 shadow h-100 rounded-tr-lg">
                      <Link
                        to={`/mockup?id=${item?.listing?.id}`}
                        className="card-img-wrapper position-relative"
                      >
                        <img
                          src={
                            item?.listing?.use_main_file_as_thumbnail
                              ? item?.listing?.compressed_file
                              : item?.thumbnails?.[0]?.image
                          }
                          className="card-img-top rounded-tr-lg"
                          alt="Product 1"
                        />
                        {item?.listing &&
                          (() => {
                            const sale = getActiveSale(item);
                            return sale.active &&
                              sale.percentage != null &&
                              !item?.listing?.is_free ? (
                              <div
                                className="position-absolute z-3 text-center fw-bold text-white small"
                                style={{
                                  top: "10px",
                                  left: "10px",
                                  backgroundColor: "#C93312",
                                  padding: "4px 10px",
                                  borderRadius: "8px",
                                  fontSize: "12px",
                                }}
                              >
                                Sale {sale.percentage}%
                              </div>
                            ) : null;
                          })()}
                      </Link>

                      <div className="card-body text-center">
                        <h5 className="card-title text-start mb-1 testelips d-none d-lg-block">
                          {item?.listing?.title}
                        </h5>
                        <p className="card-title text-start mb-1 testelips d-lg-none">
                          {item?.listing?.title}
                        </p>

                        <div
                          style={{
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            minHeight: "75px",
                          }}
                        >
                          <p
                            className="card-text text-start mb-1 d-none d-lg-block"
                            style={{
                              margin: 0,
                              fontSize: "16px",
                            }}
                          >
                            {item?.listing?.short_description}
                          </p>

                          <p
                            className="card-text text-start mb-1 d-lg-none"
                            style={{
                              margin: 0,
                              fontSize: "14px",
                            }}
                          >
                            {item?.listing?.short_description}
                          </p>
                        </div>
                        <div className="d-none d-lg-block">
                          <h2
                            className="d-flex text-center fw-bold justify-content-center align-items-baseline flex-wrap"
                            style={{ fontSize: "32px", marginTop: "16px" }}
                          >
                            {(() => {
                              const saleInfo = getActiveSale(item);
                              const salePrice = getSalePriceDisplay(item?.listing?.price, saleInfo);
                              return <SalePriceLabel salePrice={salePrice} />;
                            })()}
                          </h2>

                          {!item?.is_bought &&
                            !item?.is_bundle_linked_and_bought &&
                            !isAdmin ? (
                            !profiledata?.is_suspended && (
                              <Link
                                to={`/mockup?id=${item?.listing?.id}`}
                                className="red-buy mt-2 mb-hidden"
                                variant="contained"
                                style={{ textTransform: "capitalize" }}
                              >
                                Buy
                              </Link>
                            )
                          ) : (
                            <Link
                              to={`/mockup-editor?id=${item?.listing?.id}`}
                              className="grey-use mt-2 mb-hidden"
                              variant="contained"
                              style={{ textTransform: "capitalize" }}
                            >
                              Use
                            </Link>
                          )}
                          <div className="text-muted mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000", overflow: "hidden" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                        <div className="d-lg-none d-flex flex-column flex-md-row justify-content-between align-items-center w-full">
                          <h2
                            className="d-flex fw-bold align-items-center text-center gap-2 flex-wrap"
                            style={{ fontSize: "32px", marginTop: "16px" }}
                          >
                            {(() => {
                              const saleInfo = getActiveSale(item?.listing);
                              const salePrice = getSalePriceDisplay(item?.listing?.price, saleInfo);
                              return <SalePriceLabel salePrice={salePrice} />;
                            })()}
                          </h2>

                          <div className="text-muted text-center mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
                )}
              </div>
              <div className="d-none d-lg-flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "price",
                      "price",
                      "Browse our manually curated list of mockups ",
                      "Featured Mockups",
                    )
                  }
                />
              </div>
              <div className="d-lg-none flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "price",
                      "price",
                      "Browse our manually curated list of mockups ",
                      "Featured Mockups",
                    )
                  }
                />
              </div>
            </div>

          </section>

          {featuredSections[0] &&
            renderFeaturedSectionBlock(featuredSections[0], 0)}

          <section
            className=" py-3 my-lg-5 "
            style={{ backgroundColor: "#F7D2B4" }}
          >
            <div className="container">
              <h2 className="text-start fw-bold mb-1">Most Popular</h2>
              <p className="text-start mb-1">
                Browse our best sellers and most popular mockups.
              </p>

              <div className="row mb-2">
                {MostPopular?.map((item) => (
                  <div
                    className=" col-6 col-lg-3 lg-mb-3 p-1 px-lg-2 "
                    key={item.id}
                  >
                    <div className="card p-2 shadow h-100 rounded-tr-lg">
                      <Link
                        to={`/mockup?id=${item.id}`}
                        className="card-img-wrapper position-relative"
                      >
                        <img
                          src={
                            item?.use_main_file_as_thumbnail
                              ? item?.compressed_file
                              : item?.thumbnails?.[0]?.image
                          }
                          className="card-img-top rounded-tr-lg"
                          alt="Product 1"
                        />
                        {(() => {
                          const sale = getActiveSale(item);
                          return sale.active &&
                            sale.percentage != null &&
                            !item?.is_free ? (
                            <div
                              className="position-absolute z-3 text-center fw-bold text-white small"
                              style={{
                                top: "10px",
                                left: "10px",
                                backgroundColor: "#C93312",
                                padding: "4px 10px",
                                borderRadius: "8px",
                                fontSize: "12px",
                              }}
                            >
                              Sale {sale.percentage}%
                            </div>
                          ) : null;
                        })()}
                      </Link>
                      <div className="card-body text-center">
                        <h5 className="card-title text-start mb-1 testelips d-none d-lg-block">
                          {item?.title}
                        </h5>
                        <p className="card-title text-start mb-1 testelips d-lg-none">
                          {item?.title}
                        </p>
                        <div
                          style={{
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            minHeight: "75px",
                          }}
                        >
                          <p
                            className="card-text text-start mb-1 d-none d-lg-block"
                            style={{
                              margin: 0,
                              fontSize: "16px",
                            }}
                          >
                            {item?.short_description}
                          </p>

                          <p
                            className="card-text text-start mb-1 d-lg-none"
                            style={{
                              margin: 0,
                              fontSize: "14px",
                            }}
                          >
                            {item?.short_description}
                          </p>
                        </div>
                        <div className="d-none d-lg-block">
                          <h2
                            className="d-flex fw-bold align-items-center gap-2 justify-content-center"
                            style={{ fontSize: "32px", marginTop: "16px" }}
                          >
                            {(() => {
                              const saleInfo = getActiveSale(item);
                              const salePrice = getSalePriceDisplay(item?.price, saleInfo);
                              return <SalePriceLabel salePrice={salePrice} />;
                            })()}
                          </h2>
                          {!item?.is_bought &&
                            !item?.is_bundle_linked_and_bought &&
                            !isAdmin ? (
                            !profiledata?.is_suspended && (
                              <Link
                                to={`/mockup?id=${item?.id}`}
                                className="red-buy mt-2 mb-hidden"
                                variant="contained"
                                style={{ textTransform: "capitalize" }}
                              >
                                Buy
                              </Link>
                            )
                          ) : (
                            <Link
                              to={`/mockup-editor?id=${item?.id}`}
                              className="grey-use mt-2 mb-hidden"
                              variant="contained"
                              style={{ textTransform: "capitalize" }}
                            >
                              Use
                            </Link>
                          )}
                          <div className="text-muted mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000", overflow: "hidden" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                        <div className="d-lg-none d-flex flex-column flex-md-row justify-content-between align-items-center w-full">
                          <h2
                            className="d-flex fw-bold align-items-center text-center gap-2"
                            style={{ fontSize: "32px", marginTop: "16px" }}
                          >
                            {(() => {
                              const saleInfo = getActiveSale(item);
                              const salePrice = getSalePriceDisplay(item?.price, saleInfo);
                              return <SalePriceLabel salePrice={salePrice} />;
                            })()}
                          </h2>

                          <div className="text-muted text-center mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-none d-lg-flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "order_by_sales",
                      "true",
                      "Browse our manually curated list of mockups ",
                      "Most Popular",
                    )
                  }
                />
              </div>
              <div className="d-lg-none flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "order_by_sales",
                      "true",
                      "Browse our manually curated list of mockups ",
                      "Most Popular",
                    )
                  }
                />
              </div>
            </div>
          </section>

          {/* Random Mockup Section */}
          <section
            className="d-none d-lg-block"
            style={{
              backgroundColor: "#E3EBE0",
              height: "600px",
              position: "relative",
            }}
          >
            {/* Left Arrow */}
            <button
              onClick={handleRandomPrevious}
              disabled={randomPageTransitioning}
              style={{
                position: "absolute",
                left: "20px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(255, 255, 255, 0.9)",
                border: "none",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: randomPageTransitioning ? "not-allowed" : "pointer",
                zIndex: 10,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                transition: "all 0.3s ease",
                fontSize: "20px",
                color: "#333",
                opacity: randomPageTransitioning ? 0.5 : 1,
              }}
              onMouseEnter={(e) => {
                if (!randomPageTransitioning) {
                  e.target.style.background = "rgba(255, 255, 255, 1)";
                  e.target.style.transform = "translateY(-50%) scale(1.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (!randomPageTransitioning) {
                  e.target.style.background = "rgba(255, 255, 255, 0.9)";
                  e.target.style.transform = "translateY(-50%) scale(1)";
                }
              }}
            >
              ←
            </button>

            {/* Right Arrow */}
            <button
              onClick={handleRandomNext}
              disabled={randomPageTransitioning}
              style={{
                position: "absolute",
                right: "20px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(255, 255, 255, 0.9)",
                border: "none",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: randomPageTransitioning ? "not-allowed" : "pointer",
                zIndex: 10,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                transition: "all 0.3s ease",
                fontSize: "20px",
                color: "#333",
                opacity: randomPageTransitioning ? 0.5 : 1,
              }}
              onMouseEnter={(e) => {
                if (!randomPageTransitioning) {
                  e.target.style.background = "rgba(255, 255, 255, 1)";
                  e.target.style.transform = "translateY(-50%) scale(1.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (!randomPageTransitioning) {
                  e.target.style.background = "rgba(255, 255, 255, 0.9)";
                  e.target.style.transform = "translateY(-50%) scale(1)";
                }
              }}
            >
              →
            </button>

            <div className="container h-100">
              <div className="row g-0 h-100">
                {getCurrentRandomItems().map((item, index) => (
                  <div
                    className="col-4 h-100"
                    key={item.id}
                    style={{
                      opacity: randomPageTransitioning ? 0 : 1,
                      transition: `all 0.4s ease-in-out`,
                      transitionDelay: randomPageTransitioning
                        ? "0s"
                        : `${index * 0.1}s`,
                      transform: randomPageTransitioning
                        ? "translateY(15px) scale(0.98)"
                        : "translateY(0) scale(1)",
                      filter: randomPageTransitioning ? "blur(3px)" : "blur(0)",
                    }}
                  >
                    <Link
                      to={`/mockup?id=${formatMockupId(item?.listing?.id)}`}
                      className="d-block h-100 position-relative"
                      style={{
                        overflow: "hidden",
                        textDecoration: "none",
                      }}
                    >
                      <img
                        src={
                          item?.listing?.use_main_file_as_thumbnail
                            ? item?.listing?.compressed_file
                            : item?.thumbnails?.[0]?.image
                        }
                        alt={item?.listing?.title}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          objectPosition: "center",
                          transition: "transform 0.3s ease-in-out",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "scale(1.1)";
                          const overlay =
                            e.target.nextElementSibling?.nextElementSibling;
                          if (overlay) {
                            overlay.style.opacity = "1";
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "scale(1)";
                          const overlay =
                            e.target.nextElementSibling?.nextElementSibling;
                          if (overlay) {
                            overlay.style.opacity = "0";
                          }
                        }}
                      />
                      {item?.listing &&
                        (() => {
                          const sale = getActiveSale(item.listing);
                          return sale.active &&
                            sale.percentage != null &&
                            !item?.listing?.is_free ? (
                            <div
                              className="position-absolute text-center fw-bold text-white small"
                              style={{
                                top: "10px",
                                left: "10px",
                                backgroundColor: "#C93312",
                                padding: "4px 10px",
                                borderRadius: "8px",
                                fontSize: "12px",
                                zIndex: 3,
                              }}
                            >
                              Sale {sale.percentage}%
                            </div>
                          ) : null;
                        })()}

                      {/* Right Edge Gradient Overlay */}
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          bottom: 0,
                          width: "80px",
                          background:
                            "linear-gradient(to left, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.05) 50%, transparent 100%)",
                          pointerEvents: "none",
                          zIndex: 1,
                        }}
                      />

                      {/* Hover Overlay */}
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          opacity: 0,
                          transition: "opacity 0.3s ease-in-out",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          padding: "20px",
                          pointerEvents: "none",
                          zIndex: 2,
                        }}
                      >
                        {/* Title at top */}
                        <div
                          style={{
                            alignSelf: "flex-start",
                            maxWidth: "calc(100% - 16px)",
                          }}
                        >
                          <p
                            style={{
                              margin: 0,
                              fontSize: "27px",
                              fontWeight: "bold",
                              color: "white",
                              lineHeight: "1.3",
                              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
                            }}
                          >
                            {item?.listing?.title}
                          </p>
                        </div>

                        {/* Bottom section with creator info and price */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            width: "100%",
                          }}
                        >
                          {/* Creator info at bottom left */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              backgroundColor: "rgba(255, 255, 255, 0.9)",
                              padding: "8px 12px",
                              borderRadius: "20px",
                              backdropFilter: "blur(4px)",
                            }}
                          >
                            <img
                              src={item?.user_profile || ""}
                              alt={item?.user_name}
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                border: "2px solid white",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                              }}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                            <div>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "10px",
                                  color: "#666",
                                  lineHeight: "1",
                                }}
                              >
                                By
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  color: "#333",
                                  lineHeight: "1.2",
                                }}
                              >
                                {item?.user_name?.length > 12
                                  ? `${item?.user_name?.substring(0, 12)}...`
                                  : item?.user_name}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>

              {/* Page Indicators */}
              <div
                style={{
                  position: "absolute",
                  bottom: "20px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  display: "flex",
                  gap: "8px",
                  zIndex: 10,
                }}
              >
                {Array.from(
                  { length: getTotalPages() },
                  (_, index) => index,
                ).map((page) => (
                  <button
                    key={page}
                    onClick={() => handleRandomPageClick(page)}
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      border: "none",
                      background:
                        randomCurrentPage === page
                          ? "rgba(255, 255, 255, 1)"
                          : "rgba(255, 255, 255, 0.5)",
                      cursor: randomPageTransitioning
                        ? "not-allowed"
                        : "pointer",
                      transition: "all 0.3s ease",
                      boxShadow:
                        randomCurrentPage === page
                          ? "0 2px 6px rgba(0,0,0,0.3)"
                          : "0 1px 3px rgba(0,0,0,0.2)",
                      opacity: randomPageTransitioning ? 0.6 : 1,
                    }}
                    onMouseEnter={(e) => {
                      if (
                        randomCurrentPage !== page &&
                        !randomPageTransitioning
                      ) {
                        e.target.style.background = "rgba(255, 255, 255, 0.8)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (randomCurrentPage !== page) {
                        e.target.style.background = "rgba(255, 255, 255, 0.5)";
                      }
                    }}
                  />
                ))}
              </div>
            </div>
          </section>

          <section
            className="py-3   my-lg-5"
            style={{ backgroundColor: "#B9C4C8" }}
          >
            <div className="container">
              <h2 className="text-start fw-bold mb-1"> Mockup Bundles</h2>
              <p className="text-start mb-1">
              Buy mockups in bulk and save money on individual purchases.
              </p>

              <div className="row mb-2">
                {newBundles?.map((item) => (
                  <div
                    className=" col-6 col-lg-3 lg-mb-3 p-1 px-lg-2 "
                    key={item?.id}
                  >
                    <div className="card p-2 shadow h-100 rounded-tr-lg">
                      <Link
                        to={`/bundle?id=${item?.id}`}
                        className="card-img-wrapper"
                      >
                        {item &&
                          (() => {
                            const sale = getActiveSale(item);
                            return sale.active && sale.percentage != null ? (
                              <div
                                className="position-absolute z-3 text-center fw-bold text-white small"
                                style={{
                                  top: "10px",
                                  left: "10px",
                                  backgroundColor: "#C93312",
                                  padding: "4px 10px",
                                  borderRadius: "8px",
                                  fontSize: "12px",
                                }}
                              >
                                Sale {sale.percentage}%
                              </div>
                            ) : null;
                          })()}
                        <div className="w-100">
                          <img
                            src={item?.bundle_thumbnails[0]?.image}
                            className="card-img-top rounded-tr-lg"
                            alt="Product 1"
                          />
                          <div
                            className="position-absolute z-3"
                            style={{
                              top: "10px",
                              right: "10px",
                              backgroundColor: "#C93312",
                              color: "white",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "14px",
                              pointerEvents: "none",
                            }}
                          >
                            <img
                              src="../../assets/images/BundleIcon-removebg-preview.png"
                              alt="bundle icon"
                              style={{
                                width: "25px",
                                height: "25px",
                                objectFit: "contain",
                                borderRadius: "50%",
                              }}
                            />
                          </div>
                        </div>
                      </Link>
                      <div className="card-body text-center">
                        <h5 className="card-title text-start mb-1 testelips d-none d-lg-block">
                          {item?.title}
                        </h5>
                        <p className="card-title text-start mb-1 testelips d-lg-none">
                          {item?.title}
                        </p>
                        <div
                          style={{
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            minHeight: "75px",
                          }}
                        >
                          <p
                            className="card-text text-start mb-1 d-none d-lg-block"
                            style={{
                              margin: 0,
                              fontSize: "16px",
                            }}
                          >
                            {item?.short_description}
                          </p>

                          <p
                            className="card-text text-start mb-1 d-lg-none"
                            style={{
                              margin: 0,
                              fontSize: "14px",
                            }}
                          >
                            {item?.short_description}
                          </p>
                        </div>
                        <div className="d-none d-lg-block">
                          <h2
                            className="d-flex text-center fw-bold justify-content-center align-items-baseline flex-wrap"
                            style={{ fontSize: "32px", marginTop: "16px" }}
                          >
                            {(() => {
                              const saleInfo = getActiveSale(item);
                              const salePrice = getSalePriceDisplay(item?.price, saleInfo);
                              return <SalePriceLabel salePrice={salePrice} />;
                            })()}
                          </h2>
                          {!item?.is_bought &&
                            !item?.is_bundle_linked_and_bought &&
                            !isAdmin ? (
                            !profiledata?.is_suspended && (
                              <Link
                                to={`/bundle?id=${item?.id}`}
                                className="red-buy mt-2 mb-hidden"
                                variant="contained"
                                style={{ textTransform: "capitalize" }}
                              >
                                Buy
                              </Link>
                            )
                          ) : (
                            <Link
                              to={`/bundle?id=${item?.id}`}
                              className="grey-use mt-2 mb-hidden"
                              variant="contained"
                              style={{ textTransform: "capitalize" }}
                            >
                              Use
                            </Link>
                          )}
                          <div className="text-muted mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000", overflow: "hidden" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                        <div className="d-lg-none d-flex flex-column flex-md-row justify-content-between align-items-center w-full">
                          <h2
                            className="d-flex fw-bold align-items-center text-center gap-2 flex-wrap"
                            style={{ fontSize: "32px", marginTop: "16px" }}
                          >
                            {(() => {
                              const saleInfo = getActiveSale(item);
                              const salePrice = getSalePriceDisplay(item?.price, saleInfo);
                              return <SalePriceLabel salePrice={salePrice} />;
                            })()}
                          </h2>

                          <div className="text-muted text-center mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-none d-lg-flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "bundle",
                      "bundle",
                      "Browse our manually curated list of Bundles ",
                      "Mockup Bundles",
                    )
                  }
                />
              </div>
              <div className="d-lg-none flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "bundle",
                      "bundle",
                      "Browse our manually curated list of Bundles ",
                      "Mockup Bundles",
                    )
                  }
                />
              </div>
            </div>
          </section>

          {/* White divider */}
          {/* <section
            className="py-3 d-none d-lg-block"
            style={{ backgroundColor: "#fff" }}
          ></section> */}

          <section className="my-5 bg-announcement d-none d-lg-block">
            <div className="container">
              <div className="row align-items-stretch">
                <div className="col-md-6 d-flex">
                  <div
                    className="w-100 h-100"
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      minHeight: "400px",
                    }}
                  >
                    <img
                      src={announcementImage}
                      alt="Image"
                      className="mb-hidden"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        borderTopRightRadius: "60px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-5 ">
                  <div className="py-5 text-center">
                    <br />
                    <br />
                    <br />
                    <AnnouncementHeader customColor="#ADBB96">
                      New to Mockee?
                    </AnnouncementHeader>
                    <p>
                      <strong> No worries </strong> — we'll have you creating
                      stunning mockups in no time. Check out our step-by-step
                      tutorial and learn how to turn your designs into
                      eye-catching visuals in just seconds.
                      <br />
                      It's fast, fun, and{" "}
                      <strong> no experience is needed! </strong>
                    </p>
                    <br />
                    <Link
                      className="red-buy"
                      style={{ textTransform: "capitalize" }}
                      to={`/blog/first-steps`}
                    >
                      Read
                    </Link>
                    <br />
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="py-3 py-lg-5 "
            style={{ backgroundColor: "#E3EBE0" }}
          >
            <div className="container">
              <h2 className="text-start fw-bold mb-1">Free Mockups</h2>
              <p className="text-start mb-1">
                Start using Mockee for free! Check out our collection of free
                mockups.
              </p>

              <div className="row mb-2">
                {FreeMockups?.map((item) => (
                  <div
                    className=" col-6 col-lg-3 lg-mb-3 p-1 px-lg-2 "
                    key={item.id}
                  >
                    <div className="card p-2 shadow h-100 rounded-tr-lg">
                      <Link
                        to={`/mockup?id=${item.id}`}
                        className="card-img-wrapper position-relative"
                      >
                        <img
                          src={
                            item?.use_main_file_as_thumbnail
                              ? item?.compressed_file
                              : item?.thumbnails?.[0]?.image
                          }
                          className="card-img-top rounded-tr-lg"
                          alt="Product 1"
                        />
                      </Link>
                      <div className="card-body text-center">
                        <h5 className="card-title text-start mb-1 testelips d-none d-lg-block">
                          {item?.title}
                        </h5>
                        <p className="card-title text-start mb-1 testelips d-lg-none">
                          {item?.title}
                        </p>
                        <div
                          style={{
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            minHeight: "75px",
                          }}
                        >
                          <p
                            className="card-text text-start mb-1 d-none d-lg-block"
                            style={{
                              margin: 0,
                              fontSize: "16px",
                            }}
                          >
                            {item?.short_description}
                          </p>

                          <p
                            className="card-text text-start mb-1 d-lg-none"
                            style={{
                              margin: 0,
                              fontSize: "14px",
                            }}
                          >
                            {item?.short_description}
                          </p>
                        </div>
                        <div className="d-none d-lg-block">
                          <h2
                            className="d-flex text-center fw-bold justify-content-center"
                            style={{ fontSize: "32px", marginTop: "16px" }}
                          >
                            Free
                          </h2>
                          <Link
                            className="grey-use mb-hidden mt-2"
                            to={`/mockup-editor?id=${item?.id}`}
                            variant="contained"
                            style={{ backgroundColor: "#000" }}
                          >
                            Use
                          </Link>
                          <div className="text-muted mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000", overflow: "hidden" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                        <div className="d-lg-none d-flex flex-column flex-md-row justify-content-between align-items-center w-full">
                          <h2
                            className="d-flex text-center fw-bold justify-content-center"
                            style={{ fontSize: "32px", marginTop: "16px" }}
                          >
                            Free
                          </h2>

                          <div className="text-muted text-center mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000", overflow: "hidden" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-none d-lg-flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "price",
                      "free",
                      "Our collection of free mockups for you to use!",
                      "Free Mockups",
                    )
                  }
                />
              </div>
              <div className="d-lg-none flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "price",
                      "free",
                      "Our collection of free mockups for you to use!",
                      "Free Mockups",
                    )
                  }
                />
              </div>
            </div>
          </section>

          <section
            className="my-5 d-none d-lg-block"
            style={{ backgroundColor: "#B9C4C8" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div className="py-5 text-center">
                    <AnnouncementHeader customColor="#000" className="mb-2">
                      Tired of AI images?
                    </AnnouncementHeader>
                    <p className="large">
                      <strong>Looking for the real thing?</strong>
                      <br />
                      With Mockee, you're in control. Easily filter your search
                      to show only mockups made from real photography — no AI
                      involved.
                      <br />
                      And when you see a mockup labeled as "Mix," rest assured:
                      it's based on a real product photo, even if enhanced with
                      other creative techniques.
                    </p>
                  </div>
                </div>
                <div className="col-md-6 d-none d-lg-block">
                  <div
                    className="h-100"
                    style={{ position: "relative", overflow: "hidden" }}
                  >
                    <img
                      src={announcement2Image}
                      alt="Announcement 2"
                      className="mb-hidden"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        borderTopLeftRadius: "60px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {featuredSections[1] &&
            renderFeaturedSectionBlock(featuredSections[1], 1)}

          <section
            className="py-3  mb-lg-0"
            style={{ backgroundColor: "#B9C4C8" }}
          >
            <div className="container">
              <h2 className="text-start fw-bold mb-1">New Mockups</h2>
              <p className="text-start mb-1">Browse recently added mockups.</p>

              <div className="row mb-2">
                {NewMockups?.map((item) => (
                  <div
                    className=" col-6 col-lg-3 lg-mb-3 p-1 px-lg-2 "
                    key={item.id}
                  >
                    <div className="card p-2 shadow h-100 rounded-tr-lg">
                      <Link
                        to={`/mockup?id=${item.id}`}
                        className="card-img-wrapper position-relative"
                      >
                        <img
                          src={
                            item?.use_main_file_as_thumbnail
                              ? item?.compressed_file
                              : item?.thumbnails?.[0]?.image
                          }
                          className="card-img-top rounded-tr-lg"
                          alt="Product 1"
                        />
                        {(() => {
                          const sale = getActiveSale(item);
                          return sale.active &&
                            sale.percentage != null &&
                            !item?.is_free ? (
                            <div
                              className="position-absolute z-3 text-center fw-bold text-white small"
                              style={{
                                top: "10px",
                                left: "10px",
                                backgroundColor: "#C93312",
                                padding: "4px 10px",
                                borderRadius: "8px",
                                fontSize: "12px",
                              }}
                            >
                              Sale {sale.percentage}%
                            </div>
                          ) : null;
                        })()}
                      </Link>
                      <div className="card-body text-center">
                        <h5 className="card-title text-start mb-1 testelips d-none d-lg-block">
                          {item?.title}
                        </h5>
                        <p className="card-title text-start mb-1 testelips d-lg-none">
                          {item?.title}
                        </p>
                        <div
                          style={{
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            minHeight: "75px",
                          }}
                        >
                          <p
                            className="card-text text-start mb-1 d-none d-lg-block"
                            style={{
                              margin: 0,
                              fontSize: "16px",
                            }}
                          >
                            {item?.short_description}
                          </p>

                          <p
                            className="card-text text-start mb-1 d-lg-none"
                            style={{
                              margin: 0,
                              fontSize: "14px",
                            }}
                          >
                            {item?.short_description}
                          </p>
                        </div>
                        <div className="d-none d-lg-block">
                          <h2
                            className="d-flex fw-bold align-items-center gap-2 justify-content-center"
                            style={{ fontSize: "32px", marginTop: "16px" }}
                          >
                            {(() => {
                              const saleInfo = getActiveSale(item);
                              const salePrice = getSalePriceDisplay(item?.price, saleInfo);
                              return <SalePriceLabel salePrice={salePrice} />;
                            })()}
                          </h2>
                          {!item?.is_bought &&
                            !item?.is_bundle_linked_and_bought &&
                            !isAdmin ? (
                            !profiledata?.is_suspended && (
                              <Link
                                to={`/mockup?id=${item?.id}`}
                                className="red-buy mt-2 mb-hidden"
                                variant="contained"
                                style={{ textTransform: "capitalize" }}
                              >
                                Buy
                              </Link>
                            )
                          ) : (
                            <Link
                              to={`/mockup-editor?id=${item?.id}`}
                              className="grey-use mt-2 mb-hidden"
                              variant="contained"
                              style={{ textTransform: "capitalize" }}
                            >
                              Use
                            </Link>
                          )}
                          <div className="text-muted mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000", overflow: "hidden" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                        <div className="d-lg-none d-flex  flex-column flex-md-row justify-content-between align-items-center w-full">
                          <h2
                            className="d-flex fw-bold align-items-center text-center gap-2"
                            style={{ fontSize: "32px", marginTop: "16px" }}
                          >
                            {(() => {
                              const saleInfo = getActiveSale(item);
                              const salePrice = getSalePriceDisplay(item?.price, saleInfo);
                              return <SalePriceLabel salePrice={salePrice} />;
                            })()}
                          </h2>

                          <div className="text-muted text-center mt-2">
                            By{" "}
                            <Link
                              to={`/browse-mockups?name=${item?.user_id}`}
                              style={{ color: "#000", overflow: "hidden" }}
                            >
                              {item?.user_name}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-none d-lg-flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "price",
                      "new",
                      "Browse newest additions to our mockup database.",
                      "New Mockups",
                    )
                  }
                />
              </div>
              <div className="d-lg-none flex align-items-end justify-content-end">
                <ShowMoreButtonStatic
                  onClick={() =>
                    handlenNavigateSearchpage(
                      "price",
                      "new",
                      "Browse newest additions to our mockup database.",
                      "New Mockups",
                    )
                  }
                />
              </div>
            </div>
          </section>
          {featuredSections[2] && renderFeaturedSectionBlock(featuredSections[2], 2)}

        </div>
    </>
  );
};

export default Home;
